import React from 'react';
import { FormComponent, FormComponentProps } from '../index';
import css from './group.module.css';

export default function Group(
  elements: FormComponent[],
  title?: string,
  subGroups: boolean = false,
  noBorder: boolean = false,
  horizontal?: boolean,
  className?: string
): FormComponent {
  return ({ ...rest }) => (
    <GroupComponent
      elements={elements}
      title={title}
      subGroups={subGroups}
      noBorder={noBorder}
      horizontal={horizontal}
      className={className}
      {...rest}
    />
  );
}

export function GroupComponent({
  elements,
  title,
  subGroups,
  noBorder,
  horizontal,
  className,
  ...rest
}: FormComponentProps & {
  elements: FormComponent[];
  title?: string;
  subGroups: boolean;
  noBorder?: boolean;
  horizontal?: boolean;
  className?: string;
}) {
  const children = elements
    .filter((element) => !!element)
    .map((Child: FormComponent, index: number) => {
      return <Child key={index} {...rest} />;
    });

  if (elements.length === 0) {
    return null;
  } else if (subGroups) {
    return <fieldset className={css['group']}>{children}</fieldset>;
  } else {
    return (
      <fieldset
        className={`${noBorder ? css['group-no-border'] : css['group']} ${
          horizontal ? css['horizontal'] : ''
        } ${className} ${css[className]}`}
      >
        {title && <legend>{title}</legend>}
        <div className={css['set']}>
          <div className={`${css['fields']}`}>{children}</div>
        </div>
      </fieldset>
    );
  }
}
